import { OfflineSessionPing } from '../update-session/update-session.interfaces';

export interface OfflineSyncFields {
  offlineSessionPings: OfflineSessionPing[];
}

export const OFFLINE_SYNC_FIELDS = ['offlineSessionPings'];
